'use client';

import React from 'react';
import styles from './ThankYouModal.module.scss';
import CloseIcon from '../../../../../src/assets/icons/close.svg';
import CircleCheck from '../../../../../src/assets/icons/circle-check.svg';
import CircleFail from '../../../../../src/assets/icons/circle-fail.svg';
import { Image, Text } from '@sitecore-jss/sitecore-jss-react';

const ThankYouModal = ({ visible, onClose, fields, result }) => {
  if (!visible) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.content}>
          <button className={styles.closeButton} onClick={onClose} aria-label="Close modal">
            <img src={CloseIcon} alt={'x'} />
          </button>
          <div className={styles.icon}>
            <img src={result ? CircleCheck : CircleFail} alt={'✔'} />
          </div>
          <h3 className={styles.title}>
            {result ? fields?.submitOkTitle?.value : fields?.submitFailTitle?.value}
          </h3>
          <p className={styles.text}>
            <Text field={result ? fields?.submitOkMessage : fields?.submitFailMessage} />
          </p>
        </div>
        <button className={styles.okayButton} onClick={onClose}>
          <Text field={result ? fields?.submitOkBtnText : fields?.submitFailBtnText} />
        </button>
      </div>
    </div>
  );
};

export default ThankYouModal;
